<template lang="pug">
.gzzoc-pdf-wrapper
    .gzzoc-pdf
        img.logo(src="~public/images/gzzoc/logo-pdf.png")
        .title
            | {{$t('gzzoc.reportTitle')}}
        .person
            .item
                |{{$t('gzzoc.name')}}：{{result.name}}
            .item
                |{{$t('gzzoc.gender')}}: {{result.gender}}
            .item
                |{{$t('gzzoc.age')}}: {{result.age}}
        
        .capture-dom(v-if="showCapture") 
        .result-wrapper.thin-border-top
            .result-content(v-for='(item, index) in result.report')
                .result-img
                    img(:src="imgsrc(item.img)")
                    span.side {{item.side}}
                .result-item(v-if='item.diagnose && item.diagnose[0]')
                    .result-title {{item.diagnose[0].title}}
                    .result-description.has-big-font
                        label {{item.diagnose[0].explain}}
                .result-item.thin-border-top
                    .result-description.result-small-text
                        label(v-if='item.photo && item.photo[0]') {{item.photo[0].title}}：{{item.photo[0].explain}}
                        label(v-if='item.severity && item.severity[0]') {{item.severity[0].title}}：{{item.severity[0].explain}}
                .result-item.thin-border-top(v-if='item.treatment && item.treatment[0]')
                    .result-title {{item.treatment[0].title}}
                    .result-description.has-big-font
                        label {{item.treatment[0].explain}}
</template>

<script>
import _ from 'lodash';
import { languages, loadLanguageAsync } from "@/locale";

export default {
    data () {
        return {
            result: {
                report: []
            },
            showCapture: false
        };
    },
    computed: {
        id () {
            return this.$route.params.taskId;
        },
        date () {
            return this.$route.params.date;
        },
        lang () {
            return _.find(languages, {lang: this.$i18n.locale}) || languages[0];
        }
    },
    async mounted () {
        let lang = _.get(this.$route, 'params.lang');
        if (lang) {
            await loadLanguageAsync(lang);
        }
        this.getResult();
    },
    methods: {
        imgsrc (src) {
            return '/api/upl/s3/download/big/file?_id=' + src;
        },
        getResult () {
            this.$http.get('/api/mli/predict_model/task_result', {
                params: {
                    task_id: this.id,
                    lang: this.lang.lang
                }
            }).then(resp => {
                const status = _.get(resp, 'body.value.data.status');
                // 成功
                if (status === 'completed') {
                    const result = _.get(resp, 'body.value.data.results', {});
                    this.result = result;
                    return;
                }
            }).finally(() => {
                this.$nextTick(() => {
                    setTimeout(() => { // 解决截图中存在loading状态的bug
                        this.showCapture = true;
                    }, 300);
                });
            });
        }
    }
    
};
</script>

<style lang="sass" scoped>
.gzzoc-pdf-wrapper
    width: 100%
    height: 100%
    background-color: #FFF
    overflow-y: hidden
.gzzoc-pdf
    background-color: #FFF
    margin: 0 auto
    color: #000
    transform-origin: top center
    transform: scale(0.8, 0.8)
    .logo
        width: 196px
        height: 28px
    .title
        font-size: 24px
        line-height: 24px
        text-align: center
        margin-top: 20px
        white-space: pre-wrap
    .person
        font-family: STSongti-SC-Regular
        font-size: 12px
        color: #000
        line-height: 12px
        margin-top: 20px
        padding-bottom: 15px
        display: flex
        justify-content: center
        .item
            display: inline-block
            margin: 0 30px
    .result-wrapper
        padding-top: 20px
        display: flex
        flex: 1 1
        justify-content: center
        .result-content
            &:not(:last-child)
                margin-right: 34px
        .result-img
            display: flex
            flex-direction: column
            img
                width: 340px
                height: 340px
                background-color: #F9F9F9
                object-fit: contain
            .side
                font-family: STSongti-SC-Regular
                font-size: 12px
                color: #000000
                text-align: center
                margin-top: 10px
        .result-side
            background: #fff
            width: 52px
            height: 24px
            line-height: 24px
            border-radius: 12px
            text-align: center
            justify-content: center
            margin: 18px auto
        .result-item
            padding-top: 10px
            padding-bottom: 10px
            color: #000
            &:first-child
                padding-top: 20px
            &:last-child
                padding-bottom: 0px
            .result-title
                font-size: 12px
                line-height: 17px
            .result-description
                font-size: 12px
                label
                    line-height: 12px
                    vertical-align: top
                    display: inline-block
                    width: 45%
                    margin-right: 5%
                &.has-big-font
                    label:first-child
                        display: block
                        width: 100%
                        font-family: STSongti-SC-Bold
                        font-size: 18px
                        line-height: 25px
                        color: #000
                        margin-top: 5px
            .result-small-text
                font-size: 12px
                line-height: 17px
</style>
